import axios from "http/customAxios";
import { useMemo } from "react";

export interface CreatedAccountResponse {
  accountId: string;
  accountLink: string;
  accountLinkExpiresAt: number;
}

export interface CreatedNewLinkResponse {
  accountLink: string;
  accountLinkExpiresAt: number;
}

export interface ErrorResponse {
  message: string;
}

export class StripePaymentsApi {
  constructor(private readonly baseUrl: string, private readonly propertyTicker: string) {}

  async createConnectedAccount(paymentMethod: string): Promise<CreatedAccountResponse> {
    const response = await axios.post(
      `${this.baseUrl}/stripe/${this.propertyTicker}/account`,
      undefined,
      {
        headers: {
          "x-payment-method": paymentMethod,
        },
      }
    );

    if (response.status !== 200) {
      const errorResponse: ErrorResponse = await response.data;
      throw new Error("Error creating Stripe account: " + errorResponse.message);
    }

    return response.data;
  }

  async createNewAccountLink(paymentMethod: string): Promise<CreatedNewLinkResponse> {
    const response = await axios.post(
      `${this.baseUrl}/stripe/${this.propertyTicker}/account/link`,
      undefined,
      {
        headers: {
          "x-payment-method": paymentMethod,
        },
      }
    );

    if (response.status !== 200) {
      const errorResponse: ErrorResponse = await response.data;
      throw new Error("Error creating Stripe account link: " + errorResponse.message);
    }

    return response.data;
  }
}

export function useStripePaymentsApi(baseUrl: string, propertyTicker: string) {
  const api = useMemo(() => new StripePaymentsApi(baseUrl, propertyTicker), [
    baseUrl,
    propertyTicker,
  ]);

  return {
    createConnectedAccount: (paymentMethod: string) => api.createConnectedAccount(paymentMethod),
    createNewAccountLink: (paymentMethod: string) => api.createNewAccountLink(paymentMethod),
  };
}
